import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlockModalDragDirective } from './block-modal-drag.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [BlockModalDragDirective],
  exports: [BlockModalDragDirective],
})
export class BlockModalDragModule {}
